import React, { useEffect, useState } from "react";
import DishIcon from "../../../assets/images/svgs/cards/dish.svg";
import DeliveryIcon from "../../../assets/images/svgs/cards/delivery.svg";
import OrdersIcon from "../../../assets/images/svgs/cards/orders.svg";
import { LuSun, LuMoon } from "react-icons/lu";
import Deliver from "../../Cards/Deliver";
import { useNavigate } from "react-router-dom";
import DeleteSwal from "../../Swals/DeleteSwal";
import { useDispatch, useSelector } from "react-redux";
import { getOrderList, onCancelOrder } from "../../../redux/thunks/orderThunk";
import Pagination from "../../Pagination";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import CardShimmer from "../../Preloader/CardShimmer";
import { FileMinus } from "lucide-react";
import { MdOutlineCancel } from "react-icons/md";
import { encryptId } from "../../../utils/urlCrypto";

const normalizeStatus = (status) => {
  if (!status || status === "all") return undefined;
  if (status === "cancelled") return "cancelled";
  return status;
};

const AllCards = ({ filterStatus, search, start_date, end_date }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [orderDate, setOrderDate] = useState();
  const [Curr, setCurr] = useState();
  const { getOrders, pagination, isOrderListing } = useSelector(
    (state) => state.order,
  );
  const { current_page, total_pages } = pagination;

  const ordersArray = Array.isArray(getOrders)
    ? getOrders
    : getOrders?.orders || [];

  useEffect(() => {
    setPage(1);
  }, [search, start_date, end_date, filterStatus]);

  useEffect(() => {
    const formatDate = (date) => {
      if (!date) return undefined;

      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    };

    dispatch(
      getOrderList({
        page,
        page_type: "order",
        search,
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        status: normalizeStatus(filterStatus),
      }),
    )
      .unwrap()
      .then((res) => {
        const getCurr = res.data?.currency_symbol;
        setCurr(getCurr);
      });
  }, [page, search, start_date, end_date, filterStatus, dispatch]);

  // console.log("🔥 Dates:", start_date, end_date, "Page:", page);

  const handleCancel = async (orderId) => {
    DeleteSwal({
      title: "Cancel order?",
      text: "Are you sure you want to cancel this order?",
      confirmText: "Yes Cancel",
      cancelText: "Go Back",
      icon: MdOutlineCancel,
      cancleColor: "",
      note: "",
      onConfirm: async () => {
        const order = ordersArray.find((o) => o.order_id === orderId);
        if (!order) return;

        const payload = {
          order_id: order.order_id,
          service_provider_customer_id: order.service_provider_customer_id,
          is_confirmed: 1,
        };
        // console.log("The payload is :", payload);

        try {
          const res = await dispatch(onCancelOrder(payload)).unwrap();
          if (res.success) {
            toast.success(res.message || "Order cancelled successfully");
            // window.location.reload();
          } else {
            toast.error(res.message || "Failed to cancel order");
          }
        } catch (err) {
          console.error(err);
          toast.error("Something went wrong!");
        }
      },
    });
  };

  const formatDateTime12 = (dateTime) => {
    if (!dateTime) return "";
    const date = new Date(dateTime.replace(" ", "T"));
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour12: true,
    });
  };

  const canDeliverTodayOrPast = (orderDate) => {
    if (!orderDate) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const oDate = new Date(orderDate);
    oDate.setHours(0, 0, 0, 0);

    return oDate <= today;
  };

  const handleOnDelivery = (orderId) => {
    const order = ordersArray.find((o) => o.order_id === orderId);
    if (!order) return;

    if (!canDeliverTodayOrPast(order.order_date)) {
      Swal.fire({
        title: "⚠️ Future Order",
        html: `
    <p style="font-size:14px; color:#555;">
      You can deliver only <b>present</b> and <b>past</b> orders.<br/>
      <span style="color:#FF6943;">
         <b>Future orders</b> can be delivered on the given date.
      </span>
    </p>
  `,
        icon: "warning",
        showConfirmButton: true,
        confirmText: "ok",
        confirmButtonColor: "#FF6943",
        background: "#fff",
        color: "#191919",
        iconColor: "#FFB700",
        customClass: {
          popup: "rounded-xl shadow-lg",
          title: "font-semibold text-lg",
          confirmButton: "px-6 py-2 rounded-md",
        },
      });

      return;
    }
    navigate(`/order-delivery/${encryptId(orderId)}`);
  };

  const getInitials = (name = "") => {
    const words = name.trim().split(" ").filter(Boolean);

    if (words.length === 0) return "";

    // If only one word → return first 2 letters
    if (words.length === 1) {
      return words[0].slice(0, 2).toUpperCase();
    }

    // If multiple words → first letter of first & second word
    return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  };
  return (
    <>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {isOrderListing ? (
          Array(6)
            .fill(0)
            .map((_, i) => <CardShimmer key={i} className="h-32" />)
        ) : ordersArray.length === 0 ? (
          <div className="col-span-full flex justify-center items-center py-10 text-gray-400">
            <div className="text-center flex flex-col items-center space-y-3">
              <FileMinus size={65} className="text-gray-300" />
              <h1 className="text-lg font-semibold text-gray-700">
                No Booking Found
              </h1>
              <p className="text-sm text-gray-500">
                No orders for the selected filter
              </p>
            </div>
          </div>
        ) : (
          ordersArray.map((order) => (
            <Deliver
              key={order.order_id}
              from="order"
              status={order.status}
              to={`/order-details/${encryptId(order.order_id)}`}
              initial={getInitials(order.customer_name)}
              title={order.customer_name}
              date={order.order_date}
              formattedDate={formatDateTime12(order.order_date)}
              description={order.meal_name}
              descIcon={OrdersIcon}
              delType={order.delivery_type}
              delIcon={DeliveryIcon}
              items={order.quantity}
              itemIcon={DishIcon}
              mealType={order.meal_timing}
              mealIcon={
                order.meal_timing === "Lunch" ? (
                  <LuSun size={15} />
                ) : (
                  <LuMoon size={15} />
                )
              }
              price={`${Curr} ${Number(order.amount).toFixed(2)}`}
              onCanClick={() => handleCancel(order.order_id)}
              onDeliclick={() => handleOnDelivery(order.order_id)}
              canDeliver={canDeliverTodayOrPast(order.order_date)}
            />
          ))
        )}
      </div>

      {ordersArray.length > 0 && total_pages > 1 && (
        <Pagination
          current={current_page}
          total={total_pages}
          onPageChange={setPage}
        />
      )}
    </>
  );
};

export default AllCards;
